module.exports = __webpack_public_path__ + "static/images/components/ReserveProgress/images/gradient.b123f157.png";


//////////////////
// WEBPACK FOOTER
// ./components/ReserveProgress/images/gradient.png
// module id = 2662
// module chunks = 11